import React, { useState, useEffect, useContext } from 'react';
import { AsCheckbox, AsButton } from '@adserve/adserve-react-components';
import { GetPackage } from '../../../services/DataService';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';
const AddPackageDialog = ({ campaign, campaignPackage, addPackageCallBack, cancelPackage }) => {
    const { formatCurrency } = useContext(SystemSettingsContext);

    const [selectedStations, setSelectedStations] = useState([]);
    const [weeks, setWeeks] = useState([]);
    const [definition, setDefinition] = useState({});
    const [pack, setPack] = useState({});
    const [typeStates, setTypeStates] = useState({
        airtimeSelected: false,
        sponsSelected: false,
        promosSelected: false,
        livesSelected: false,
        airtimeValid: false,
        sponsValid: false,
        promosValid: false,
        livesValid: false
    });

    const clearallstations = () => {
        setSelectedStations([]);
    };
    const selectallstations = () => {
        const selIds = definition?.activeStations.map((a, b) => a.id);
        setSelectedStations(selIds);
    };

    const addPackage = () => {
        const selectedWeeks = weeks.filter((a) => a.selected);
        const packageDefinition = {
            stations: selectedStations,
            weeks: selectedWeeks.map((a, b) => a.startDate),
            elements: typeStates,

            packageName: pack.name,
            packageId: pack.id,
            campaignId: campaign.id,
            id: campaignPackage.id
        };
        addPackageCallBack(packageDefinition);
    };

    useEffect(() => {
        if (campaignPackage?.packageId) {
            GetPackage(campaignPackage?.packageId).then((data) => {
                const def = data?.definition ? JSON.parse(data.definition) : {};

                setDefinition(def);
                const state = extractState(def);
                setTypeStates(state);
                const wks = extractWeeks(data);
                setWeeks(wks);

                if (campaignPackage?.stations) {
                    setSelectedStations(campaignPackage?.stations);
                } else {
                    const selIds = def?.activeStations?.map((a, b) => a.station.id);

                    setSelectedStations(selIds);
                }
                if (campaignPackage.weeks) {
                    const wklookup = {};
                    campaignPackage.weeks.map((a, b) => {
                        wklookup[new Date(a).valueOf()] = true;
                    });
                    wks.map((a, b) =>
                        wklookup[new Date(a.startDate).valueOf()] ? (a.selected = true) : (a.selected = false)
                    );
                }
                setPack(data);
            });
        }
    }, [campaignPackage]);
    const extractState = (def) => {
        let hasAirtime = false;
        let hasSpons = false;
        let hasPromos = false;
        let hasLives = false;
        def?.airtimeSpots?.map((a, b) => {
            hasAirtime =
                hasAirtime ||
                a.reduce(function (accumVariable, curValue) {
                    return accumVariable + curValue ? 1 : 0;
                }, 0);
        });
        def?.liveSpots?.map((a, b) => {
            hasLives =
                hasLives ||
                a.reduce(function (accumVariable, curValue) {
                    return accumVariable + curValue ? 1 : 0;
                }, 0);
        });
        def?.sponsSpots?.map((a, b) => {
            hasSpons =
                hasSpons ||
                a.reduce(function (accumVariable, curValue) {
                    return accumVariable + curValue ? 1 : 0;
                }, 0);
        });

        def?.promoSpots?.map((a, b) => {
            hasPromos =
                hasPromos ||
                a.reduce(function (accumVariable, curValue) {
                    return accumVariable + curValue ? 1 : 0;
                }, 0);
        });
        let state = { airtimeValid: hasAirtime, airtimeSelected: hasAirtime };
        state = { ...state, livesValid: hasLives, livesSelected: hasLives };
        state = { ...state, promosValid: hasPromos, promosSelected: hasPromos };
        state = { ...state, sponsValid: hasSpons, sponsSelected: hasSpons };
        return state;
    };
    useEffect(() => {}, [pack, campaign]);
    const extractWeeks = () => {
        const wks = [];
        const firstMonday = new Date(campaign?.startDate);
        while (firstMonday.getDay() !== 1) {
            firstMonday.setDate(firstMonday.getDate() - 1);
        }
        const today = new Date();
        while (firstMonday.valueOf() < today.valueOf()) {
            firstMonday.setDate(firstMonday.getDate() + 7);
        }
        const enddate = new Date(campaign?.endDate);
        while (firstMonday.valueOf() < enddate.valueOf()) {
            let yr = firstMonday.getFullYear();
            let mn = firstMonday.getMonth() + 1;
            let dy = firstMonday.getDate();
            const startDate = yr + '-' + (mn > 9 ? mn : '0' + mn) + '-' + (dy > 9 ? dy : '0' + dy);

            firstMonday.setDate(firstMonday.getDate() + 7);
            yr = firstMonday.getFullYear();
            mn = firstMonday.getMonth() + 1;
            dy = firstMonday.getDate();
            const lbl = startDate + '/' + yr + '-' + (mn > 9 ? mn : '0' + mn) + '-' + (dy > 9 ? dy : '0' + dy);
            wks.push({ name: lbl, selected: true, startDate: startDate + 'T00:00:00' });
        }
        return wks;
    };
    useEffect(() => {
        if (campaignPackage?.weeks) {
            weeks.map((a, b) => {
                return (a.selected = false);
            });
            campaignPackage.weeks.map((a, b) => {
                var wk = weeks.find((w) => new Date(w.startDate).valueOf() === new Date(a).valueOf());
                if (wk) wk.selected = true;
            });
        }
        if (campaignPackage?.stations) {
            setSelectedStations(campaignPackage.stations);
        }
        if (campaignPackage?.elements) {
            setTypeStates(campaignPackage?.elements);
        }
    }, [campaign, campaignPackage]);
    const stationClick = (e) => {
        if (selectedStations.find((s) => s == e.target.value)) {
            setSelectedStations(selectedStations.filter((s) => s != e.target.value));
        } else {
            setSelectedStations([...selectedStations, e.target.value]);
        }
    };
    const selectallweeks = () => {
        weeks.map((a, b) => (a.selected = true));
        setWeeks([...weeks]);
    };
    const clearallweeks = () => {
        weeks.map((a, b) => (a.selected = false));
        setWeeks([...weeks]);
    };
    const weekClick = (e) => {
        weeks[e.target.value - 1].selected = !weeks[e.target.value - 1].selected;

        setWeeks([...weeks]);
    };
    const typesChange = (e) => {
        typeStates[e.target.name] = e.target.checked;
        setTypeStates({ ...typeStates });
    };

    const StationList = () => {
        return (
            <fieldset style={{ width: '100%' }}>
                <legend>Select Stations</legend>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div>
                        <div
                            style={{
                                height: 600,
                                margin: 10,
                                fontSize: 14,
                                color: '#414141',
                                overflow: 'scroll'
                            }}
                        >
                            {definition?.activeStations?.map((a, b) => {
                                return (
                                    <div key={b} style={{ textAlign: 'left', border: '1px solid #414141' }}>
                                        <AsCheckbox
                                            key={'station' + b}
                                            value={a.station.id}
                                            onChange={stationClick}
                                            checked={selectedStations?.find((s) => s == a.station.id)}
                                            label={a.station.name}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                        <AsButton
                            handleClick={clearallstations}
                            label='Clear All'
                            disabled={selectedStations?.length === 0}
                        >
                            {window.translate('Clear All')}
                        </AsButton>

                        <AsButton
                            handleClick={selectallstations}
                            disabled={selectedStations?.length === definition?.activeStations?.length}
                        >
                            {window.translate('Select All')}
                        </AsButton>
                    </div>
                </div>
            </fieldset>
        );
    };
    const ElementList = () => {
        return (
            <div style={{ display: 'flex' }}>
                <fieldset style={{ width: '100%' }}>
                    <legend>Select Elements</legend>
                    <div style={{ display: 'flex' }}>
                        {typeStates.promosValid ? (
                            <AsCheckbox
                                name='promosSelected'
                                checked={typeStates.promosSelected}
                                onChange={typesChange}
                                label='Promos'
                            ></AsCheckbox>
                        ) : (
                            <></>
                        )}
                        {typeStates.airtimeValid ? (
                            <AsCheckbox
                                name='airtimeSelected'
                                checked={typeStates.airtimeSelected}
                                onChange={typesChange}
                                label='Airtime'
                            ></AsCheckbox>
                        ) : (
                            <></>
                        )}
                        {typeStates.livesValid ? (
                            <AsCheckbox
                                name='livesSelected'
                                checked={typeStates.livesSelected}
                                onChange={typesChange}
                                label='Live Reads'
                            ></AsCheckbox>
                        ) : (
                            <></>
                        )}
                        {typeStates.sponsValid ? (
                            <AsCheckbox
                                name='sponsSelected'
                                checked={typeStates.sponsSelected}
                                onChange={typesChange}
                                label='Sponsorship'
                            ></AsCheckbox>
                        ) : (
                            <></>
                        )}
                    </div>
                </fieldset>
            </div>
        );
    };

    const WeekList = () => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <fieldset>
                    <legend>Select Weeks</legend>
                    <div style={{ display: 'flex', flexWrap: 'wrap', fontSize: 12, color: '#414141' }}>
                        {weeks.map((a, b) => {
                            return (
                                <div key={b} style={{ border: '1px solid #414141', margin: 1, width: 200 }}>
                                    <AsCheckbox
                                        key={'week' + b}
                                        value={b + 1}
                                        label={a.name}
                                        checked={a.selected}
                                        onChange={weekClick}
                                        style={{ margin: 15 }}
                                    />
                                </div>
                            );
                        })}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
                        <AsButton
                            handleClick={clearallweeks}
                            label='Clear All'
                            style={{ width: 120 }}
                            disabled={
                                weeks.reduce(function (accumVariable, curValue) {
                                    return accumVariable + (curValue.selected ? 1 : 0);
                                }, 0) === 0
                            }
                        >
                            {window.translate('Clear All')}
                        </AsButton>
                        <div style={{ width: 10 }}></div>

                        <AsButton
                            handleClick={selectallweeks}
                            style={{ width: 120 }}
                            disabled={
                                weeks.reduce(function (accumVariable, curValue) {
                                    return accumVariable + (curValue.selected ? 1 : 0);
                                }, 0) === weeks.length
                            }
                        >
                            {window.translate('Select All')}
                        </AsButton>
                    </div>
                </fieldset>
            </div>
        );
    };
    const ReservationParams = () => {
        return (
            <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: 20, paddingRight: 20 }}>
                <AsButton handleClick={cancelPackage} style={{ width: 120 }}>
                    {window.translate('Cancel')}
                </AsButton>
                <div style={{ width: 10 }}></div>
                <AsButton handleClick={addPackage} style={{ width: 120 }}>
                    {window.translate('OK')}
                </AsButton>
            </div>
        );
        /*
        return (
            <div>
                <table>
                    <tr>
                        <td>Book Price</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Reservation Price</td>
                        <td>
                            {' '}
                            <AsNumber
                                onChange={reservationPriceChange}
                                value={reservationPrice}
                                formatCurrency={formatCurrency}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Reservation Time</td>
                        <td>
                            {' '}
                            <AsSelect
                                id='reservation-time'
                                style={{
                                    width: 260,
                                    marginTop: -1
                                }}
                                values={reservationTimes}
                                value={reservationTimeId}
                                onChange={handleReservationChange}
                                placeholder={window.translate('Select...')}
                            />
                        </td>
                        <td>
                            <AsButton handleClick={addPackage} tyle={{ width: 200 }}>
                                {window.translate('Add to campaign')}
                            </AsButton>
                        </td>
                    </tr>
                </table>
            </div>
        );
        */
    };
    return (
        <>
            <div>
                <h1>{pack?.name}</h1>
                Weekly Price {formatCurrency(pack.recommendedPriceOneWeek) || '£0.00'}
                <div style={{ display: 'flex' }}>
                    <div style={{ width: '20%', marginRight: '5%', display: 'none' }}>
                        <StationList></StationList>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                height: '80%',
                                flexDirection: 'column'
                            }}
                        >
                            <div style={{ display: 'none' }}>
                                {' '}
                                {/* not required just now */}
                                <ElementList></ElementList>
                            </div>
                            <WeekList></WeekList>
                            <ReservationParams campaignPackage={campaignPackage}></ReservationParams>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default AddPackageDialog;
